import request from "@/utils/http"

export function createDashboard(board, appId) {
  return request.post(`/bi/createDashboard`, board, { params: { appId } }).commonDeal()
}

export function copyDashboard(id) {
  return request.post(`/bi/copyDashboard`, {}, { params: { id } }).commonDeal()
}

export function getManageDashboardList(appId) {
  return request.get("/bi/getManageDashboardList", { params: { appId } }).commonDeal()
}

export function deleteDashboard(id) {
  return request.get("/bi/deleteDashboard", { params: { id } }).commonDeal()
}

export function getDashboard(id) {
  return request.get("/bi/getDashboard", { params: { id } }).commonDeal()
}

export function updateDashboard(board) {
  return request.post(`/bi/updateDashboard`, board).commonDeal()
}

export function updateCharts(board) {
  return request.post(`/bi/updateCharts`, board).commonDeal()
}

// 自动取数
export function getAutoSaveChartList(appId) {
  return request.get(`/bi/getAutoSaveChartList`, { params: { appId } }).commonDeal()
}

export function getAutoSaveChart(appId, id) {
  return request.get(`/bi/getAutoSaveChart`, { params: { appId, id } }).commonDeal()
}

export function saveAutoSaveChartDataTask(rule) {
  return request.post(`/bi/saveAutoSaveChartDataTask`, rule).commonDeal()
}

export function deleteAutoSaveChart(appId, id) {
  return request.post(`/bi/deleteAutoSaveChart`, {}, { params: { appId, id } }).commonDeal()
}

// 看板分享
export function upsertDashboardShare(share) {
  return request.post(`/bi/upsertDashboardShare`, share).commonDeal()
}

export function deleteDashboardShare(dashboardId) {
  return request.get(`/bi/deleteDashboardShare`, { params: { dashboardId } }).commonDeal()
}

export function getDashboardShare(dashboardId) {
  return request.get(`/bi/getDashboardShare`, { params: { dashboardId } }).commonDeal()
}

export function share(dashboardShareId, password) {
  return request.post(`/public/dashboard/share`, {}, { params: { dashboardShareId, password } })
}
